/* mh-ksa-market.js — Saudi market storefront layer (Phase 1).
 *
 * - "Deliver to" selector injected beside the language switcher (QA / SA).
 * - Market persisted in the mh_market cookie; first visit defaults by geo-IP
 *   (api/geo.php) — Saudi visitors auto-land on the Saudi view.
 * - Switching to SA submits Shopify's /localization form (country=SA) so
 *   CHECKOUT charges the ksa market's +30% QAR price list — the margin is
 *   collected by Shopify, not faked in JS.
 * - Display: rendered QAR amounts (already +30% in SA context) are shown as
 *   SAR using the fixed admin rate (api/ksa_config.php). Cart/checkout keep
 *   QAR with a small "charged in QAR" note (multi-currency checkout needs
 *   Shopify Payments, unavailable in Qatar).
 * - Middleware content: homepage / mega-menu / delivery badges fetch with
 *   market=sa (separate Saudi homepage, auto-derived Saudi category tree,
 *   editable "3-5 days delivery" promise).
 */
(function () {
  'use strict';

  var API = 'https://admin.menahub.com/api';

  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function setCookie(n, v) {
    document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=31536000; SameSite=Lax';
  }

  // Dedicated Saudi store (Option B): this theme ships ONLY to the KSA
  // storefront (ksa.menahub.com / br33ws-bf), so the market is ALWAYS Saudi —
  // there is no QA/SA switch here. The mh_market cookie/switcher belongs to the
  // Qatar store's single-store market toggle (Option A) and is irrelevant here.
  getCookie; // (kept for the config revalidation helpers below)
  window.MH_MARKET = 'sa';

  // PayLater is Qatar-only. In the Saudi market, flag <html> and hide every
  // PayLater surface (card badge, /mo instalment, PDP explainer, deal-card
  // badges). product-card-new already omits it server-side when country=SA;
  // this covers client-hydrated surfaces (deal cards, PDP) too. The !important
  // rule beats the inline display:block the PDP explainer sets via JS.
  if (window.MH_MARKET === 'sa') {
    document.documentElement.classList.add('mh-market-sa');
    try {
      var plStyle = document.createElement('style');
      plStyle.textContent =
        'html.mh-market-sa .mh-pl-card-badge,' +
        'html.mh-market-sa .mh-pl-monthly,' +
        'html.mh-market-sa .mh-ps-link--pl,' +
        'html.mh-market-sa #menahub-paylater-tag{display:none !important}';
      document.head.appendChild(plStyle);
    } catch (e) {}
  }
  var isAr = /^\/ar(\/|$)/.test(location.pathname) || (document.documentElement.lang || '').indexOf('ar') === 0;

  var cfg = null; // ksa config cache
  function loadCfg() {
    if (cfg) return Promise.resolve(cfg);
    try {
      var ls = JSON.parse(localStorage.getItem('mh_ksa_cfg') || 'null');
      if (ls && ls._t && Date.now() - ls._t < 60000) { cfg = ls; return Promise.resolve(cfg); }
    } catch (e) {}
    return fetch(API + '/ksa_config.php').then(function (r) { return r.json(); }).then(function (d) {
      cfg = d || {};
      cfg._t = Date.now();
      try { localStorage.setItem('mh_ksa_cfg', JSON.stringify(cfg)); } catch (e) {}
      return cfg;
    }).catch(function () { return (cfg = { enabled: false }); });
  }

  // Stale-while-revalidate: whatever loadCfg() served (possibly cached), also
  // fetch a FRESH copy and react immediately if the middleware flipped the
  // market switch — no waiting out cache TTLs.
  function revalidateCfg() {
    // Canonical URI (no cache-buster): the middleware purges this URI's server
    // cache on toggle, so a no-store fetch here is fresh the moment it flips.
    fetch(API + '/ksa_config.php', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d) return;
        d._t = Date.now();
        try { localStorage.setItem('mh_ksa_cfg', JSON.stringify(d)); } catch (e) {}
        var wasEnabled = cfg && cfg.enabled;
        cfg = d;
        if (!d.enabled) {
          var btn = document.getElementById('mh-market-btn');
          var menu = document.getElementById('mh-market-menu');
          if (btn) btn.remove();
          if (menu) menu.remove();
          if (window.MH_MARKET === 'sa') switchMarket('qa');
        } else if (!wasEnabled) {
          injectSelector(d);
        }
      })
      .catch(function () {});
  }

  // Switch the Shopify country context (drives the +30% ksa price list at
  // checkout) and remember the middleware market, then reload.
  function switchMarket(target) {
    if (target === window.MH_MARKET) return;
    setCookie('mh_market', target);
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    var fields = {
      _method: 'put',
      country_code: target === 'sa' ? 'SA' : 'QA',
      return_to: location.pathname + location.search
    };
    Object.keys(fields).forEach(function (k) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = k; i.value = fields[k];
      form.appendChild(i);
    });
    document.body.appendChild(form);
    form.submit();
  }
  window.mhSwitchMarket = switchMarket;

  // ── First visit: geo-IP default ────────────────────────────────────────
  function geoDefault() {
    if (market !== '') return; // user already has a market
    setCookie('mh_market', 'qa'); // provisional so we never loop
    fetch(API + '/geo.php').then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.country === 'SA') {
        loadCfg().then(function (c) { if (c.enabled) switchMarket('sa'); });
      }
    }).catch(function () {});
  }

  // ── Header selector: globe icon → dropdown with SVG flags ─────────────
  // (emoji flags render as bare "QA"/"SA" text on Windows — use inline SVGs)
  var FLAG_QA = '<svg viewBox="0 0 60 30" width="26" height="13" style="border-radius:2px;flex:none" aria-hidden="true"><rect width="60" height="30" fill="#8A1538"/><path d="M0 0H22L14 3.33L22 6.66L14 10L22 13.33L14 16.66L22 20L14 23.33L22 26.66L14 30H0Z" fill="#fff"/></svg>';
  var FLAG_SA = '<svg viewBox="0 0 60 30" width="26" height="13" style="border-radius:2px;flex:none" aria-hidden="true"><rect width="60" height="30" fill="#165d31"/><rect x="16" y="19.5" width="28" height="2.4" rx="1.2" fill="#fff"/><text x="30" y="14.5" text-anchor="middle" font-size="8.5" fill="#fff" font-family="serif">\u0644\u0627 \u0625\u0644\u0647 \u0625\u0644\u0627 \u0627\u0644\u0644\u0647</text></svg>';
  var GLOBE = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#fff" stroke-width="1.7" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.6 3.8 5.7 3.8 9S14.5 18.4 12 21M12 3c-2.5 2.6-3.8 5.7-3.8 9s1.3 6.4 3.8 9"/></svg>';

  function flagHtml(code) { return code === 'sa' ? FLAG_SA : FLAG_QA; }

  function injectSelector(c) {
    if (!c.enabled) return;
    // Pick a VISIBLE anchor. On mobile the desktop language switcher
    // (.setting-wrap.language) is display:none, so the selector would land in a
    // hidden node — fall back to the visible mobile header row instead.
    var _vis = function (el) {
      if (!el) return false;
      var r = el.getBoundingClientRect(); var s = window.getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden' && r.width > 0 && r.height > 0;
    };
    var _lang = document.querySelector('.setting-wrap.language');
    var _mobileRow = document.querySelector('.header-small-mobile .header-right-wrap');
    var anchor, insertMode;
    if (_lang && _vis(_lang)) { anchor = _lang; insertMode = 'before'; }
    else if (_mobileRow && _vis(_mobileRow)) { anchor = _mobileRow; insertMode = 'prepend'; }
    else { anchor = _lang || document.querySelector('#mh-lang-backdrop') || document.querySelector('header .header-right, header'); insertMode = 'before'; }
    if (!anchor || document.getElementById('mh-market-btn')) return;

    var label = isAr ? '\u0627\u062e\u062a\u0631 \u0628\u0644\u062f \u0627\u0644\u062a\u0648\u0635\u064a\u0644' : 'Choose delivery country';
    var btn = document.createElement('button');
    btn.id = 'mh-market-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', label);
    btn.title = label;
    btn.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;gap:4px;background:none;border:0;padding:4px 2px;margin:0 2px;cursor:pointer;color:inherit;line-height:1;white-space:nowrap;flex:none;';
    btn.innerHTML = GLOBE + '<span style="display:inline-flex;flex:none">' + flagHtml(window.MH_MARKET) + '</span>';

    var menu = document.createElement('div');
    menu.id = 'mh-market-menu';
    menu.style.cssText = 'display:none;position:absolute;z-index:3000;background:#fff;color:#0f172a;border:1px solid #e2e8f0;border-radius:14px;box-shadow:0 12px 32px rgba(15,23,42,0.18);padding:8px;min-width:220px;';
    var head = document.createElement('div');
    head.textContent = isAr ? '\u0627\u0644\u062a\u0648\u0635\u064a\u0644 \u0625\u0644\u0649' : 'Deliver to';
    head.style.cssText = 'font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.4px;color:#94a3b8;padding:4px 10px 8px;';
    menu.appendChild(head);
    [['qa', isAr ? '\u0642\u0637\u0631' : 'Qatar'], ['sa', isAr ? '\u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629' : 'Saudi Arabia']].forEach(function (opt) {
      var o = document.createElement('button');
      o.type = 'button';
      var active = window.MH_MARKET === opt[0];
      o.style.cssText = 'display:flex;align-items:center;gap:10px;width:100%;padding:9px 10px;border:0;background:' + (active ? '#fff7ed' : 'none') + ';border-radius:10px;cursor:pointer;font-size:14px;font-weight:600;text-align:start;white-space:nowrap;';
      o.innerHTML = flagHtml(opt[0]) + '<span>' + opt[1] + '</span>' + (active ? '<span style="margin-inline-start:auto;color:#e28534;font-weight:800">\u2713</span>' : '');
      o.addEventListener('click', function () { switchMarket(opt[0]); });
      o.addEventListener('mouseenter', function () { if (!active) o.style.background = '#f8fafc'; });
      o.addEventListener('mouseleave', function () { if (!active) o.style.background = 'none'; });
      menu.appendChild(o);
    });

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = menu.style.display === 'block';
      menu.style.display = open ? 'none' : 'block';
      if (!open) {
        var r = btn.getBoundingClientRect();
        menu.style.top = (r.bottom + 8 + window.scrollY) + 'px';
        var ltr = document.documentElement.dir !== 'rtl';
        if (ltr) menu.style.left = Math.min(Math.max(8, r.left), window.innerWidth - 236) + 'px';
        else menu.style.left = Math.max(8, r.right - 220) + 'px';
      }
    });
    document.addEventListener('click', function () { menu.style.display = 'none'; });

    if (insertMode === 'prepend') anchor.insertBefore(btn, anchor.firstChild);
    else anchor.parentNode.insertBefore(btn, anchor);
    document.body.appendChild(menu);
  }

  // ── SAR display conversion (SA only) ───────────────────────────────────
  // Rendered prices are QAR and ALREADY include the +30% market price list,
  // so display conversion is rate-only. Cart/checkout keep QAR.
  // Matches both orders and both digit systems:
  //   "QAR 299" / "QR299"           (currency first, Latin digits)
  //   "299 QAR" / "٢٩٩ ر.ق"        (amount first, Latin or Arabic-Indic digits)
  var NUM = '[\\d\\u0660-\\u0669][\\d\\u0660-\\u0669,\\u066C]*(?:[.\\u066B][\\d\\u0660-\\u0669]{1,2})?';
  var MONEY_BEFORE = new RegExp('(QAR|QR|\\u0631\\.\\u0642)\\s?(' + NUM + ')', 'g');
  var MONEY_AFTER  = new RegExp('(' + NUM + ')\\s?(QAR|QR|\\u0631\\.\\u0642)', 'g');
  function toLatinDigits(s) {
    return s.replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
            .replace(/٬/g, ',').replace(/٫/g, '.');
  }
  function sarText(num, rate, arabicStyle) {
    var v = parseFloat(toLatinDigits(num).replace(/,/g, ''));
    if (!isFinite(v)) return null;
    var sar = v * rate;
    if (arabicStyle) {
      return sar.toLocaleString('ar-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ر.س';
    }
    return 'SAR ' + sar.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function convertNode(root, rate) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('QAR') < 0 && n.nodeValue.indexOf('QR') < 0 && n.nodeValue.indexOf('ر.ق') < 0) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'INPUT') return NodeFilter.FILTER_REJECT;
        if (p.closest('[data-mh-no-sar]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var NUM_ONLY = new RegExp('^\\s*(' + NUM + ')\\s*$');
    var CUR_ONLY = /^\s*(QAR|QR|ر\.ق)\s*$/;
    nodes.forEach(function (n) {
      var t = n.nodeValue;
      t = t.replace(MONEY_BEFORE, function (_, cur, num) {
        var out = sarText(num, rate, cur === 'ر.ق');
        return out === null ? _ : out;
      });
      t = t.replace(MONEY_AFTER, function (_, num, cur) {
        var out = sarText(num, rate, cur === 'ر.ق');
        return out === null ? _ : out;
      });
      if (t !== n.nodeValue) { n.nodeValue = t; return; }
      // Split-node case: currency lives alone in its own element
      // (e.g. <span class="mh-cur">QAR</span>5,299.00) with the amount
      // in a sibling text node of the wrapping element.
      var cm = n.nodeValue.match(CUR_ONLY);
      if (!cm) return;
      var curEl = n.parentElement, wrap = curEl && curEl.parentElement;
      if (!wrap || wrap.closest('[data-mh-no-sar]')) return;
      for (var i = 0; i < wrap.childNodes.length; i++) {
        var sib = wrap.childNodes[i];
        if (sib.nodeType !== 3) continue;
        var nm = sib.nodeValue.match(NUM_ONLY);
        if (!nm) continue;
        var out = sarText(nm[1], rate, cm[1] === 'ر.ق');
        if (out === null) continue;
        // sarText returns "SAR 1,234.00" or "١٬٢٣٤٫٠٠ ر.س" — split back apart
        if (cm[1] === 'ر.ق') {
          n.nodeValue = n.nodeValue.replace(cm[1], 'ر.س');
          sib.nodeValue = out.replace(/\s*ر\.س\s*$/, '');
        } else {
          n.nodeValue = n.nodeValue.replace(cm[1], 'SAR');
          sib.nodeValue = out.replace(/^SAR\s*/, '');
        }
        break;
      }
    });
  }

  function enableSarDisplay(c) {
    // Shopify-hosted checkout (/checkouts/…) settles in QAR and can't be
    // reliably re-skinned, so leave it in QAR — that's the real charge currency.
    if (/^\/checkouts?(\/|$)/.test(location.pathname)) return;

    var isCart = /^\/cart(\/|$)/.test(location.pathname);
    // Option B (separate KSA store): products are SYNCED at their final SAR
    // value (mh_ksa_sar_price = QAR base × fx × margin), and Shopify shows that
    // amount labelled "QAR" only because the store's base currency is QAR. So
    // display conversion here is a PURE RELABEL — QAR→SAR with the SAME number.
    // Do NOT re-apply the fx rate (that would double-convert). If the KSA store
    // ever holds Qatar-base prices instead, restore the config rate here.
    var rate = 1.0;
    var run = function () { convertNode(document.body, rate); };
    run();

    // On the cart page show SAR like the rest of the store, with a small note
    // that the actual charge settles in QAR at checkout (no SAR settlement yet).
    if (isCart) {
      var note = document.createElement('div');
      note.setAttribute('data-mh-no-sar', '1');
      note.style.cssText = 'background:#fff7ed;border:1px solid #fdba74;color:#9a3412;border-radius:10px;padding:10px 14px;margin:10px auto;max-width:1200px;font-size:13px;font-weight:600;';
      note.textContent = isAr
        ? 'الأسعار معروضة بالريال السعودي (تقريبية). يتم تحصيل المبلغ بالريال القطري عند إتمام الدفع.'
        : 'Prices shown in SAR (approx.). Your card is charged the equivalent in Qatari Riyal at checkout.';
      var main = document.querySelector('main') || document.body;
      main.insertBefore(note, main.firstChild);
    }

    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 300);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // ── Hide Qatar-only legacy homepage sections on SA ─────────────────────
  function hideQatarLegacy() {
    if (location.pathname.replace(/^\/ar/, '') !== '/' && location.pathname !== '/ar') return;
    document.querySelectorAll('.offer-zone, [id*="offer_zone"], .shopify-section .offer-zone__container').forEach(function (el) {
      var sec = el.closest('.shopify-section') || el;
      sec.style.display = 'none';
    });
  }

  // ── Boot ───────────────────────────────────────────────────────────────
  // Dedicated Saudi store: no geo default, no QA/SA switcher, no "revert to
  // Qatar" path — the market is unconditionally Saudi. Always relabel prices to
  // SAR and hide any Qatar-only legacy homepage sections. Reference the
  // now-unused Option-A helpers so linters/minifiers keep them for the archive.
  // hideQatarLegacy is intentionally NOT called: the KSA store shows a full copy
  // of the Qatar homepage/content (only product availability differs), so we no
  // longer hide any Qatar homepage sections. Kept referenced for the archive.
  void switchMarket; void geoDefault; void revalidateCfg; void injectSelector; void loadCfg; void hideQatarLegacy;
  function boot() {
    document.documentElement.classList.add('mh-market-sa');
    enableSarDisplay({ rate: 1.0 });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
